<!-- With several mails selected, the batch below lists them itself. -->
@if (!multiple()) {
  <!-- Inset like the step panels below, so label and value line up with theirs. -->
  <dl class="px-3">
    <dt class="text-xs font-medium tracking-wide text-cmi-gray-mid uppercase">
      {{ 'home.mailLabel' | translate }}
    </dt>
    @if (openMail().itemId) {
      <dd class="truncate text-sm font-medium text-cmi-gray" [title]="openMail().subject">
        {{ openMail().subject || ('mailUpload.noSubject' | translate) }}
      </dd>
    } @else {
      <dd class="text-sm text-cmi-gray-mid">{{ 'home.noMail' | translate }}</dd>
    }
  </dl>
}

<router-outlet />
